import type * as Types from '../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly roles: ReadonlyArray<Types.AccountsUserRole>, readonly totalCompaniesCount: number, readonly restrictions: { readonly __typename?: 'AccountsRestriction', readonly aliveCompaniesCount?: number | null, readonly totalCompaniesCount?: number | null }, readonly subscription: { readonly __typename?: 'YalperSubscription', readonly isTrial: boolean }, readonly company?: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly name: string, readonly tokens: ReadonlyArray<{ readonly __typename?: 'OauthProviderToken', readonly id: string, readonly lastError?: string | null, readonly provider: Types.OauthProvider, readonly accounts: ReadonlyArray<{ readonly __typename?: 'YalperAccount', readonly id: string, readonly name: string }> }> } | null } | null };


export const GetCurrentUserDocument = gql`
    query GetCurrentUser($id: ID) {
  currentUser {
    restrictions {
      aliveCompaniesCount
      totalCompaniesCount
    }
    roles
    subscription {
      isTrial
    }
    totalCompaniesCount
    company(id: $id) {
      id
      name
      tokens {
        id
        lastError
        provider
        accounts {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;